import { useState } from "react";
import { url } from "../utils/config";
import Input from "../reusable_components/Input";
import Select from "../reusable_components/Select";
import postData from "../custom_functions/postData";
import { toast } from "react-toastify";
import currency from "../utils/currency";
import Button from "../reusable_components/Button";
import { btnCancel, btnOne, inputStyle, label, modalContainer, modalTitle } from "../utils/style";



function AddResourceCharge(props) {
    const [ formData, setFormData ] = useState({});
    const [ missingFields, setMissingFields ] = useState([]);
    const [ inputErrors, setInputErrors ] = useState([]);
    const [ showInputError, setShowInputError ] = useState(false);

    const requiredFields = ['name', 'cost', 'currency', 'type'];
    const typeList = ['Material', 'Other'];
    const validCurrency = ['CAD']

    async function addResource() {
        if(
            formData.name && formData.name.length > 0 &&
            formData.cost && formData.cost > 0 &&
            formData.currency && currency.includes(formData.currency) &&
            formData.type && typeList.includes(formData.type) &&
            !inputErrors.includes('error')
            ) {
            postData(`${url}/resource_charge`, formData, (error => {
                toast.error(error.response.data.message, { autoClose: 3000 })
           }), (data) => {
                toast.success(data.message, { autoClose: 3000 })
                props.setShowModal(false)
                props.reload(1 + Math.random())
           })
        } else {
            let fields = Object.keys(formData);
            let miss = [];
            if (fields.length !== requiredFields.length) {
                requiredFields.forEach(field => {
                    if(!fields.includes(field))  {
                        miss.push(field)
                    }
                    if(field.name === 'currency' && !validCurrency.includes(formData[field.name])) {
                        miss.push(field)
                    }
                })
            };
            setMissingFields(miss);
            setShowInputError(true)
        }
    }

    function updateFormData (e) {
        const { name, value} = e.target;
        var data = {...formData};
        data[name] = value;
        setFormData(data);
    }

    return(
        <div className={modalContainer}>
            <div className="bg-white rounded-lg p-4 w-1/2">
                <div  className={modalTitle}>Add Resource & Charges</div>
                <div>
                    <div className="grid grid-cols-3">
                        <div className={label}>Resource Name</div>
                        <div className="col-span-2">
                            <Input 
                                index={0}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='name' 
                                type='text'
                                placeHolder='Enter Resource Name'
                                value={formData.name} 
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-3">
                        <div className={label}>Resource Cost/Hr</div>
                        <div className="col-span-2">
                            <Input 
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                className={inputStyle}
                                name='cost' 
                                type='number'
                                placeHolder='Enter Cost per Hour'
                                value={formData.cost} 
                                onChange={e => updateFormData(e)}
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-3">
                        <div className={label}>Currency</div>
                        <div className="col-span-2">
                            <Select 
                                testId={'currency'}
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                options={currency}
                                className={inputStyle}
                                name='currency' 
                                placeHolder='Currency'
                                validCurrency={validCurrency}
                                value={formData.currency} 
                                onChange={e => updateFormData(e)} 
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-3">
                        <div className={label}>Resource Type</div>
                        <div className="col-span-2">
                            <Select 
                                testId={'type'}
                                index={1}
                                inputErrors={inputErrors}
                                setInputErrors={setInputErrors}
                                missingFields={missingFields}
                                required={true}
                                options={typeList}
                                className={inputStyle}
                                name='type' 
                                placeHolder='Resource Type'
                                value={formData.type} 
                                onChange={e => updateFormData(e)} 
                            />
                            </div>
                    </div>
                </div>
                <div className="flex justify-between py-3 px-16 gap-8">
                    <button onClick={() => props.setShowModal(false)} className={btnCancel}>Cancel</button>
                    <Button clickHandler={() => addResource()} className={btnOne} name={'Submit'} />
                </div>
                <div className="text-red-500 font-semibold text-center">
                    {
                        showInputError && 'Please fill all the fields as directed!'
                    }
                </div>
            </div>
        </div>
    )
}

export default AddResourceCharge;